import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DivisionsPage = lazy(() => import('../pages/divisions/page'));
const InvestorRelationsPage = lazy(() => import('../pages/investor-relations/page'));
const DigitalAssetsPage = lazy(() => import('../pages/digital-assets/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/divisions',
    element: <DivisionsPage />,
  },
  {
    path: '/investor-relations',
    element: <InvestorRelationsPage />,
  },
  {
    path: '/digital-assets',
    element: <DigitalAssetsPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;